import { parseISO } from "date-fns";
import { Entity } from "@common/types/entity";
import { useEntities } from "./useEntities";
import { useMemoByKeys } from "./useMemoByKeys";

/**
 * Returns the effective bookkeeping start date for a set of entities,
 * computed as the earliest (minimum) bookkeepingStartDate among the
 * filtered entities. When no entityIds filter is provided, considers
 * all entities in the workspace.
 */
export function useEffectiveBookkeepingStartDate(
    entityIds?: number[],
): Date | null {
    const entities: Entity[] = useEntities();
    const entityIdsKey = entityIds?.join(",");

    return useMemoByKeys(() => {
        const relevantEntities =
            entityIds && entityIds.length > 0
                ? entities.filter((entity) => entityIds.includes(entity.id))
                : entities;

        if (relevantEntities.length === 0) {
            return null;
        }

        const timestamps = relevantEntities.map((entity) =>
            parseISO(entity.bookkeepingStartDate).getTime(),
        );

        return new Date(Math.min(...timestamps));
    }, [entities, entityIdsKey]);
}
